const handlePayHereForRelianceIPA = (setClickedPayHere, paymentUrl) => {
  console.log("paymentUrl: ", paymentUrl);
  if (!paymentUrl) {
    alert("Something went wrong..");
    setClickedPayHere(false);
  }
  // By default url is for posp
  window.location.href = paymentUrl; // Open in same tab
};

export default handlePayHereForRelianceIPA;
